import React from 'react';
import { Wrench, MapPin, Search, Clock, CheckCircle2 } from 'lucide-react';
export function InstallationService() {
  return <section className="py-16 lg:py-24 bg-brand-background" data-id="element-379">
      <div className="max-w-7xl mx-auto px-4" data-id="element-380">
        <div className="bg-white rounded-2xl shadow-sm border border-brand-border overflow-hidden" data-id="element-381">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-382">
            {/* Image/Visual Side */}
            <div className="bg-brand-goldWash p-8 lg:p-12 flex flex-col items-center justify-center text-brand-charcoal relative overflow-hidden" data-id="element-383">
              <div className="absolute inset-0 opacity-[0.06]" style={{
              backgroundImage: 'radial-gradient(#1C1D21 1px, transparent 1px)',
              backgroundSize: '24px 24px'
            }} data-id="element-384"></div>
              <div className="relative z-10 text-center w-full max-w-sm" data-id="element-385">
                <div className="w-20 h-20 bg-brand-goldSoft text-brand-maroon rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-386">
                  <MapPin size={36} data-id="element-387" />
                </div>
                <h3 className="text-2xl font-serif font-bold mb-6" data-id="element-388">
                  Select Service Areas
                </h3>

                <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-389">
                  {['Maryland', 'Virginia', 'Washington DC', 'Pennsylvania', 'West Virginia'].map(state => <span key={state} className="bg-white border border-brand-border px-3 py-1 rounded-full text-sm font-medium text-brand-charcoal" data-id="element-390">
                      {state}
                    </span>)}
                </div>

                <div className="bg-white border border-brand-border rounded-xl p-5 text-left" data-id="element-391">
                  <h4 className="font-bold text-brand-charcoal mb-3 text-sm uppercase tracking-wider" data-id="element-392">
                    Diagnostic Checklist
                  </h4>
                  <ul className="space-y-2 text-sm text-brand-charcoal/80" data-id="element-393">
                    <li className="flex items-center gap-2" data-id="element-394">
                      <CheckCircle2 size={16} className="text-brand-maroon" data-id="element-395" />{' '}
                      Identify manufacturer
                    </li>
                    <li className="flex items-center gap-2" data-id="element-396">
                      <CheckCircle2 size={16} className="text-brand-maroon" data-id="element-397" />{' '}
                      Confirm HOA rules
                    </li>
                    <li className="flex items-center gap-2" data-id="element-398">
                      <CheckCircle2 size={16} className="text-brand-maroon" data-id="element-399" />{' '}
                      Check mounting type
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-400">
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-401">
                Installation and mailbox diagnostics in select Mid-Atlantic
                areas
              </h2>
              <p className="text-lg text-brand-muted mb-8" data-id="element-402">
                From residential mailbox installation to model identification,
                replacement options, and commercial estimating, MidAtlantic
                helps customers confirm the right path before committing to a
                product or project.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-403">
                <li className="flex items-start gap-3" data-id="element-404">
                  <Search className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-405" />
                  <span className="font-medium text-brand-charcoal" data-id="element-406">
                    Free residential diagnostic & estimating service
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-407">
                  <Wrench className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-408" />
                  <span className="font-medium text-brand-charcoal" data-id="element-409">
                    Model and manufacturer identification
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-410">
                  <Clock className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-411" />
                  <span className="font-medium text-brand-charcoal" data-id="element-412">
                    Replacement options and lead-time guidance
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-413">
                  <CheckCircle2 className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-414" />
                  <span className="font-medium text-brand-charcoal" data-id="element-415">
                    HOA matching support
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-416">
                  <CheckCircle2 className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-417" />
                  <span className="font-medium text-brand-charcoal" data-id="element-418">
                    Commercial estimating and route planning
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-419">
                  <MapPin className="text-brand-maroon shrink-0 mt-1" size={20} data-id="element-420" />
                  <span className="font-medium text-brand-charcoal" data-id="element-421">
                    Installation availability in select service areas
                  </span>
                </li>
              </ul>

              <a href="/Services.html" className="inline-flex items-center justify-center bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3.5 rounded-md font-semibold transition-colors w-full sm:w-auto" data-id="element-422">
                Ask about installation
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}